import React from 'react'
import { Col } from 'antd'
import * as UI from 'konsys-ui'
import moment from 'moment'
import _ from 'lodash'
import { detailMode } from '../constants'
import { DatePicker } from '../styled'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Upload box
5: Select
6: TextArea
7: Upload
*/

const CreateMode = ({
  data, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (data.type) {
    case 2:
      return (
        data.id !== 'refId' && <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <UI.P margin='8px 0 16px' bold>
            {
              data.dataType === 'date'
                ? moment(initialData[data.id]).format('DD/MM/YYYY')
                : data.id === 'jobDealType'
                  ? (initialData[data.id] === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว')
                  : !_.includes(['createdDate', 'refId'], data.id)
                  && initialData[data.id]
            }
            </UI.P>
          </UI.Div>
        </Col>
      )
    case 4:
      return (
        <Col span={data.span} offset={data.id === 'createdDate' ? 16 : data.offset}>
          <UI.P margin='8px 0'>{data.props.title.text}</UI.P>
          <DatePicker
            onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
            defaultValue={moment(mutationVariables[data.id])}
            value={mutationVariables[data.id] !== 'Invalid date' && moment(mutationVariables[data.id])}
            {...data.props}
          />
        </Col>
      )
    case 5:
      return (
        <Col
          span={data.span}
          style={{}}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.H4 margin='8px 0 16px' bold>{data.props.title.text}</UI.H4>
          </UI.Div>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler,
}) => {
  switch (data.type) {
    case 2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <UI.P margin='8px 0 16px' bold>{data.dataType === 'date'
              ? moment(initialData[data.id]).format('DD/MM/YYYY')
              : data.id === 'jobDealType'
                ? (initialData[data.id] === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว')
                : initialData[data.id]
            }</UI.P>
          </UI.Div>
        </Col>
      )
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P margin='8px 0'>{data.props.title.text}</UI.P>
          <DatePicker
            onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
            disabled={disabled}
            defaultValue={_.isNull(initialData[data.id]) ? initialData[data.id] : moment(initialData[data.id])}
            {...data.props}
          />
        </Col>
      )
    case 5:
      return (
          <Col
            span={data.span}
            style={{}}
          >
            <UI.Div display='flex' flexDirection='column' margin='0'>
              <UI.H4 margin='8px 0 16px' bold>{data.props.title.text}</UI.H4>
            </UI.Div>
          </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={(id, value) => onChangeHandler(id, value)} initialData={initialData} mutationVariables={mutationVariables}/>
    case detailMode.EDIT:
      return <EditMode data={data} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
